import React from 'react';

const Bar = ({
  active,
  chart_height,
  onClick,
  origin,
  round = true,
  spacing,
  stroke,
  stroke_width,
}) => {
  const bottom_stroke_fix = 4;

  const bars = active.map(({ color, label, raw, value, id }, index) => {
    const shape = `M ${origin.x + index * spacing},${chart_height -
      bottom_stroke_fix}  
             L ${origin.x + index * spacing}, ${chart_height -
      value -
      bottom_stroke_fix} `;
    return (
      <path
        key={id}
        style={{ cursor: 'pointer' }}
        d={shape}
        stroke={color}
        onClick={() => onClick({ raw, label })}
      />
    );
  });

  return (
    <g
      aria-hidden="true"
      strokeWidth={stroke_width}
      stroke={stroke}
      strokeLinecap={round ? 'round' : 'square'}
      strokeLinejoin={round ? 'round' : 'miter'}
    >
      {bars}
    </g>
  );
};
export default Bar;
